import type { HomeEventItem, UnifiedEvent } from '../../types/auth';

function urlFrom(raw: string | null | undefined): URL | null {
  if (!raw) return null;
  try {
    return new URL(raw, 'https://agapella.local');
  } catch {
    return null;
  }
}

export function parseUnifiedEventRef(
  raw: string | null | undefined,
): { source: UnifiedEvent['source']; id: number } | null {
  const url = urlFrom(raw);
  const match = url?.pathname.match(/^\/events\/([^/]+)\/(\d+)\/?$/);
  if (!match) return null;
  const source = match[1].toLowerCase();
  if (source !== 'master' && source !== 'agape') return null;
  const id = Number(match[2]);
  return Number.isFinite(id) ? { source, id } : null;
}

export function resolveHomeEventRegistrationRef(
  item: HomeEventItem,
): { source: UnifiedEvent['source']; id: number } {
  return parseUnifiedEventRef(item.detailsUrl) || { source: 'master', id: item.id };
}

/**
 * CORE-1286 — адрес карточки-КОМНАТЫ: `/room/{инвайт-код}`.
 *
 * Главная отдаёт комнаты и лайвы одним списком с `type: "live"` — для человека
 * это одна и та же «Live-сессия». Различает их только адрес, и различать
 * обязательно: id у `Lives` и `WatchParties` независимые, поэтому id комнаты,
 * прочитанный как id лайва, молча открывает ДРУГУЮ сессию.
 */
export function parseHomeRoomCode(raw: string | null | undefined): string | null {
  const url = urlFrom(raw);
  const match = url?.pathname.match(/^\/room\/([^/]+)\/?$/);
  const code = match?.[1];
  return code ? decodeURIComponent(code) : null;
}

export function parseHomeLiveEventId(raw: string | null | undefined): number | null {
  const url = urlFrom(raw);
  if (!url) return null;
  const pathMatch = url.pathname.match(/^\/lives?\/(\d+)\/?$/);
  const rawId = pathMatch?.[1];
  if (!rawId) return null;
  const id = Number(rawId);
  return Number.isFinite(id) ? id : null;
}

export function resolveHomeLiveEventId(item: HomeEventItem): number | null {
  const kind = (item.type || '').toLowerCase();
  if (kind === 'offline' || kind === 'online') return null;
  // Комната — не лайв: откат на item.id ниже отправил бы её id в LiveDetail и
  // в напоминания по лайвам, где под этим номером лежит чужая сессия.
  if (parseHomeRoomCode(item.detailsUrl) != null) return null;
  const parsedId = parseHomeLiveEventId(item.detailsUrl);
  return kind === 'live' ? (parsedId ?? item.id) : parsedId;
}

export function homeEventRegistrationKey(item: HomeEventItem): string {
  const roomCode = parseHomeRoomCode(item.detailsUrl);
  if (roomCode) return `room:${roomCode}`;
  const liveId = resolveHomeLiveEventId(item);
  if (liveId != null) return `live:${liveId}`;
  const ref = resolveHomeEventRegistrationRef(item);
  return `${ref.source}:${ref.id}`;
}
